<template>
  <div class="project-settings-advanced">
    <Section>
      <div class="section-body">
        <ProjectVideoCrawlerSettings :project="project" />
      </div>
    </Section>
  </div>
</template>

<script>
import Section from '@/components/Section.vue';
import ProjectVideoCrawlerSettings from '@/project/ProjectVideoCrawlerSettings.vue';

export default {
  props: ['project'],
  components: {
    Section,
    ProjectVideoCrawlerSettings,
  },
};
</script>

<style lang="scss" scoped>
@import '@/assets/scss/variables.scss';
</style>
